angular.module('aprima-provider-api').factory('SettingRepository',
    ['AprimaRestangular', 'DashboardStructure', '_',
        function (AprimaRestangular, DashboardStructure, _) {
            'use strict';

            var configToPhoneConfigMapper = _.partialRight(mapToDeviceConfig, 'PhoneTiles');
            var configToTabletConfigMapper = _.partialRight(mapToDeviceConfig, 'TabletTiles');
            var configToDesktopConfigMapper = _.partialRight(mapToDeviceConfig, 'DesktopTiles');

            return {
                providerDashboard: providerDashboard,
                userSettings: userSettings,
                patientDashboardTiles: patientDashboardTiles,
                patientDashboardConfigurations: patientDashboardConfigurations,
                createPatientDashboardConfiguration: createPatientDashboardConfiguration,
                updatePatientDashboardConfiguration: updatePatientDashboardConfiguration,
                deletePatientDashboardConfiguration: deletePatientDashboardConfiguration,
                getDrugSearchIncludeInactive: getDrugSearchIncludeInactive,
                getProviderSettings: getProviderSettings,
                saveProviderSettings: saveProviderSettings,
                getProviderEpcsSettings: getProviderEpcsSettings,
                getKdbConfigurationId: getKdbConfigurationId,
                getKdbConfigurationIdByVisit: getKdbConfigurationIdByVisit,
                getSigWriterSettings: getSigWriterSettings,
                siteSettings: siteSettings,
            };

            function patientDashboardTiles(){
                return AprimaRestangular.get().one('settings/patient-dashboard-tiles/').get();
            }

            function patientDashboardConfigurations() {
                var dashboardStructure = DashboardStructure.get();

                return AprimaRestangular.get()
                    .one(dashboardStructure.repositoryRoute)
                    .get()
                    .then(function(configs) {
                        configs = dashboardStructure.mapFn(configs);

                        var result = {
                            phoneConfigs: _.map(configs, configToPhoneConfigMapper),
                            tabletConfigs: _.map(configs, configToTabletConfigMapper),
                            desktopConfigs: _.map(configs, configToDesktopConfigMapper),
                            allConfigs: configs
                        };

                        return result;
                    });
            }

            function createPatientDashboardConfiguration(configuration){
                return AprimaRestangular.get().one('settings/patient-dashboards/').customPOST(configuration);
            }

            function updatePatientDashboardConfiguration(dashboardId, configuration){
                return AprimaRestangular.get().one('settings/patient-dashboards/' + dashboardId).customPUT(configuration);
            }

            function deletePatientDashboardConfiguration(dashboardId){
                return AprimaRestangular.get().one('settings/patient-dashboards/' + dashboardId).remove();
            }

            function providerDashboard(userid) {
                return AprimaRestangular.get().one('settings/providerdashboard/' + userid).get();
            }

            function userSettings(userid) {
                return AprimaRestangular.get().one('settings/usersettings/' + userid).get();
            }

            function siteSettings() {
                return AprimaRestangular.get().one('settings/site-settings').get();
            }

            function getProviderSettings(userId) {
                return AprimaRestangular.get().one('settings/providersettings/' + userId).get();
            }

            function getProviderEpcsSettings(userId, siteId) {
                return AprimaRestangular.get().one('settings/providersettings/' + userId + '/epcs/' + (siteId || '00000000-0000-0000-0000-000000000000')).get();
            }

            function saveProviderSettings(userId, settings) {
                return AprimaRestangular.get().one('settings/providersettings/' + userId).customPUT(settings);
            }

            function mapToDeviceConfig(config, index, collection, deviceSelector) {
                return {
                    Id: config.Id,
                    ExternalId: config.ExternalId,
                    Name: config.Name,
                    DisplayOrder: config.DisplayOrder,
                    Tiles: _.cloneDeep(config[deviceSelector])
                };
            }

            // !userId means just use the CurrentUser
            function getKdbConfigurationId(userId, renderingProviderId, billingProviderId) {
                var promise = getKdbConfiguration(userId, renderingProviderId, billingProviderId)
                    .then(function(data) {
                        if(!data) {
                            return null;
                        }

                        return data.KdbConfigurationId;
                    });
                return promise;
            }

            // !userId means just use the CurrentUser
            function getKdbConfiguration(userId, renderingProviderId, billingProviderId) {
                var params = {
                    userId: userId || null,
                    renderingProviderId: renderingProviderId || null,
                    billingProviderId: billingProviderId || null,
                };

                var promise = AprimaRestangular.get()
                    .one('settings/kdbconfiguration')
                    .get(params);
                return promise;
            }

            // !userId means just use the CurrentUser
            function getKdbConfigurationIdByVisit(userId, visitId) {
                var promise = getKdbConfigurationByVisit(userId, visitId)
                    .then(function(data) {
                        if(!data) {
                            return null;
                        }

                        return data.KdbConfigurationId;
                    });
                return promise;
            }

            // !userId means just use the CurrentUser
            function getKdbConfigurationByVisit(userId, visitId) {
                var params = {
                    userId: userId || null,
                    visitId: visitId || null,
                };

                var promise = AprimaRestangular.get()
                    .one('settings/kdbconfiguration-visit')
                    .get(params);
                return promise;
            }

            function getDrugSearchIncludeInactive(providerId) {
                var params = {
                    providerId: providerId || null
                };

                var promise = AprimaRestangular.get()
                    .one('settings/drug-search-include-inactive')
                    .get(params);
                return promise;
              }
            
            function getSigWriterSettings() {
                return AprimaRestangular.get().one('settings/sigwriter-settings').get();
            }

        }]);
